import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { withStyles, makeStyles } from '@material-ui/core/styles';

import { Grid, FormHelperText, Tooltip } from '@material-ui/core';

import http from '@common/http';

import { useTranslation } from '@common/utils';

import moment from 'moment';

import InfoOutlined from '@material-ui/icons/InfoOutlined';

const DateTooltip = withStyles({
	tooltip: {
		padding: 10,
		fontSize: 12,
	},
})(Tooltip);

function SeasonDatePreview({ dates }) {
	const classes = useStyles();
	const tr = useTranslation();
	const [seasons, setSeasons] = useState([]);
	const [selectedSeasons, setSelectedSeasons] = useState({});
	const [selected, setSelected] = useState([]);
	const [isFromChanges, setIsFromChanges] = useState(false);
	const [isToChanges, setIsToChanges] = useState(false);

	useEffect(() => {
		(async () => {
			const { data } = await http.get('/api/kiosks/student-housing/seasons?active=true');

			setSeasons(data.map(s => ({
				value: s._id,
				from: s.from,
				to: s.to,
			})));
		})().catch(console.error);
	}, []);

	useEffect(() => {
		if (!seasons || !dates?.seasons) { return; }
		let selectedSeasons = seasons.filter(s => dates.seasons.includes(s.value)).map(s => ({ from: moment(s.from).format('YYYY-MM-DD'), to: moment(s.to).format('YYYY-MM-DD') }));

		setSelected(selectedSeasons);

		let from = [];
		let to = [];

		selectedSeasons.forEach(f => (from.push(f.from), to.push(f.to)));

		const dateRange = {
			from: from.reduce(function (a, b) { return a < b ? a : b; }, null),
			to: to.reduce(function (a, b) { return a > b ? a : b; }, null),
		};
		setSelectedSeasons(dateRange);

	}, [seasons, dates]);

	useEffect(() => {
		if (!dates?.seasons) { setSelectedSeasons({}); }
	}, [dates]);

	useEffect(() => {
		setIsFromChanges(true);
		setTimeout(() => {
			setIsFromChanges(false);
		}, '400');
	}, [selectedSeasons.from]);

	useEffect(() => {
		setIsToChanges(true);
		setTimeout(() => {
			setIsToChanges(false);
		}, '400');
	}, [selectedSeasons.to]);

	return (
		<Grid style={{ position: 'relative' }}>
			<Grid className={classes.container}>
				<Grid container direction="column" className={classes.date}>
					<Grid className={classes.label} dangerouslySetInnerHTML={{ __html: tr('Check-in') }} />
					<Grid className={!isFromChanges ? classes.details : classes.bold} dangerouslySetInnerHTML={{ __html: selectedSeasons.from || '-' }} />
				</Grid>
				<Grid container direction="column" className={classes.date}>
					<Grid className={classes.label} dangerouslySetInnerHTML={{ __html: tr('Check-out') }} />
					<Grid className={!isToChanges ? classes.details : classes.bold} dangerouslySetInnerHTML={{ __html: selectedSeasons.to || '-' }} />
				</Grid>
			</Grid>
			{selected.length > 1 &&
				<Grid className={classes.helper}>
					<DateTooltip
						title="Booking can be made only for a continuous period. If you want to make a reservation for nonconsecutive seasons you need to make separate reservations"
						placement="right"
						arrow>
						<FormHelperText className={classes.helperText}>{tr('Season gaps are included')} <InfoOutlined style={{ fontSize: 14, marginLeft: '4px' }}></InfoOutlined > </FormHelperText>
					</DateTooltip>
				</Grid>
			}
		</Grid>
	);
}

SeasonDatePreview.propTypes = {
	dates: PropTypes.object.isRequired,
};

export default SeasonDatePreview;

const useStyles = makeStyles(theme => ({
	container: {
		marginLeft: '16px',
		display: 'flex',
		minWidth: '250px',
		border: '1px solid #EAEAEA',
		borderRadius: '4px',
		[theme.breakpoints.down('sm')]: {
			margin: '0 0 15px 0',
		},
	},
	date: {
		padding: '0px 8px',
		minHeight: '52px',
	},
	label: {
		color: 'rgba(0, 0, 0, .44)',
		textTransform: 'uppercase',
		fontSize: '14px',
		fontWeight: 500,
	},
	details: {
		color: 'rgba(0, 0, 0, .84)',
		fontSize: '16px',
		fontWeight: 400,
	},
	bold: {
		fontWeight: 700,
	},
	helper: {
		position: 'absolute',
	},
	helperText: {
		marginLeft: '20px',
		display: 'flex',
		alignItems: 'center',
	},
}));
